module.exports = __webpack_public_path__ + "img/notice.5738e81c.png";